import * as React from 'react';

interface ErrorPageWrapperProps {
    children: React.ReactNode;
}

const ErrorPageWrapper = ({ children }: ErrorPageWrapperProps) => {
    return (
        <div className="bg-background">
            <div>{children}</div>
        </div>
    );
};

export default ErrorPageWrapper;
